export const GLOBAL_STATE = 'AssessmentMarks'

export const ASSESSMENT_AMENDMENT = 'ASSESSMENT_AMENDMENT' as const
export const ASSESSMENT_AMENDMENT_CREATE = 'ASSESSMENT_AMENDMENT_CREATE' as const
export const ASSESSMENT_AMENDMENT_DELETE = 'ASSESSMENT_AMENDMENT_DELETE' as const
export const ASSESSMENT_AMENDMENT_LIST = 'ASSESSMENT_AMENDMENT_LIST' as const
export const ASSESSMENT_AMENDMENT_ALL = 'ASSESSMENT_AMENDMENT_ALL' as const
export const ASSESSMENT_AMENDMENT_ALL_UPDATED = 'ASSESSMENT_AMENDMENT_ALL_UPDATED' as const
export const ASSESSMENT_AMENDMENT_PUBLISH = 'ASSESSMENT_AMENDMENT_PUBLISH' as const
export const ASSESSMENT_MARK_STATUS = 'ASSESSMENT_MARK_STATUS' as const
export const ASSESSMENT_MARKS_GENERATE = 'ASSESSMENT_MARKS_GENERATE' as const
export const ASSESSMENT_ZIP_UPLOADS = 'ASSESSMENT_ZIP_UPLOADS' as const
export const ASSESSMENT_MODERATOR_FORM = 'ASSESSMENT_MODERATOR_FORM' as const
export const ASSESSMENT_MODERATOR_FORM_BULK = 'ASSESSMENT_MODERATOR_FORM_BULK' as const
export const ASSESSMENT_CU_MARK_LIST = 'ASSESSMENT_CU_MARK_LIST' as const
